/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import {
  SignalCellular0Bar,
  SignalCellular1Bar,
  SignalCellular2Bar,
  SignalCellular3Bar,
  SignalCellular4Bar,
} from '@mui/icons-material';

const icons = [
  SignalCellular0Bar,
  SignalCellular1Bar,
  SignalCellular2Bar,
  SignalCellular3Bar,
  SignalCellular4Bar,
];

const SignalStrengthIcon = forwardRef(
  ({ value, minValue, maxValue, ...props }, ref) => {
    if (value == null) return null;

    const numberOfSteps = icons.length - 1; // 4 steps between 5 icons
    const stepSize = (maxValue - minValue) / numberOfSteps;

    // Clamp the value between min and max
    const clampedValue = Math.max(minValue, Math.min(value, maxValue));

    // Determine index based on clamped value
    const index = Math.floor((clampedValue - minValue) / stepSize);
    const Icon = icons[index];

    return <Icon {...props} ref={ref} />;
  },
);

SignalStrengthIcon.propTypes = {
  value: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
};

export default SignalStrengthIcon;
